import {AbstractControl} from '@angular/forms';

export * from './modules';
export * from './guard';
export * from './models';
export * from './services';

export class PasswordValidation {
  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password'); // to get value in input tag
    const repeatPassword = AC.get('repeatPassword'); // to get value in input tag
    if ((password.touched && password.value.length >= 8 && repeatPassword.touched && repeatPassword.value.length > 0) && (password.value != repeatPassword.value)) {
      AC.get('repeatPassword').setErrors({MatchPassword: true});
    } else {
      return null;
    }
  }
}
